/* ================================================================
   RUB HUB -- tagging strip fitter
   Drops the LOWEST-PRIORITY whole tag pill until the left lane fits.
   Pills are authored high->low priority (left->right); we hide from the
   end. Whole pills only -- never a half tag, never a hang-off. The award
   coin is pinned by CSS and is never touched here.
   Runs at every point the widths can change (DOM ready, full load, web
   fonts ready, resize) and watches for AJAX-loaded cards, so a tag that
   does not fully fit is always DROPPED, never clipped.
   Idempotent: safe to load more than once (per-card include dedupes).
   ================================================================ */
(function () {
  if (window.__rhBadgesFitInit) return;
  window.__rhBadgesFitInit = true;

  function rows(pills) {
    var seen = {}, n = 0;
    pills.forEach(function (p) {
      if (p.style.display === 'none') return;
      if (!seen[p.offsetTop]) { seen[p.offsetTop] = 1; n++; }
    });
    return n;
  }
  function fit(lane) {
    var pills = Array.prototype.slice.call(lane.children);
    pills.forEach(function (p) { p.style.display = ''; });          // reset every pass
    // 2026-09-23 (Floody): the prelaunch cluster (New, Coming Soon, Pre-order) must all show,
    // so when it overflows it wraps to a 2nd row (.rh-badges--wrap, see rh-badges.css)
    // instead of dropping a pill. Only a 3rd row would force a drop.
    var strip = lane.parentNode;
    var st = strip && strip.getAttribute('data-rh-status');
    if (strip && strip.classList) strip.classList.remove('rh-badges--wrap');
    if ((st === 'preorder' || st === 'comingsoon') && lane.scrollWidth > lane.clientWidth + 1) {
      strip.classList.add('rh-badges--wrap');
      for (var j = pills.length - 1; j >= 0 && rows(pills) > 2; j--) pills[j].style.display = 'none';
      return;
    }
    var guard = 0;
    for (var i = pills.length - 1; i >= 0; i--) {
      if (lane.scrollWidth <= lane.clientWidth + 1) break;          // it fits -- stop
      pills[i].style.display = 'none';                              // drop lowest priority
      if (++guard > 20) break;
    }
  }
  function run() {
    var lanes = document.querySelectorAll('.rh-badges__tags');
    for (var i = 0; i < lanes.length; i++) fit(lanes[i]);
  }
  function schedule() { run(); if (window.requestAnimationFrame) requestAnimationFrame(run); }

  // run at every point widths can settle
  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  setTimeout(schedule, 300);                                        // late-loading fonts/CSS

  var t;
  function debounced() { clearTimeout(t); t = setTimeout(run, 120); }
  window.addEventListener('resize', debounced);

  // re-fit cards injected by AJAX pagination / collection filtering
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { debounced(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
